import { combineReducers } from 'redux'

import nvbugsCard from 'containers/Manage/Nvbugs/NvbugsCard/reducer'
import nvbugsDialog from 'containers/Manage/Nvbugs/NvbugsDialog/reducer'

export default combineReducers({
    nvbugsCard,
    nvbugsDialog
  })
  